const { errors, billetType } = require('@transfeeradev/api-enums');
const ClearMaskService = require('../services/ClearMaskService');
const error = require('./error');
const success = require('./success');
const GetTypeService = require('../services/GetTypeService');

class CollectionBarcode {
  constructor(billet) {
    this._billet = billet;

    this._billet.barcode = ClearMaskService.clear(this._billet.barcode);
  }

  validate() {
    const barcode = this.getBarcode();

    if (!barcode || GetTypeService.get(barcode) !== billetType.COLLECTION) {
      return error(errors.ptBr.bil.INVALID_BARCODE, 'barcode');
    }

    const invalidVD = this._validateVerifyingDigit();

    if (invalidVD) {
      return invalidVD;
    }

    return success;
  }

  _validateVerifyingDigit() {
    const cod = this.getBarcode();

    if (!/^[0-9]{44}$/.test(cod) || GetTypeService.get(cod) !== billetType.COLLECTION) {
      return error(errors.ptBr.bil.INVALID_BARCODE, 'barcode');
    }

    const VD = Number(cod[3]);
    const block = cod.substring(0, 3) + cod.substring(4);
    const mod = this._getMod(cod);

    if (!mod) {
      return error(errors.ptBr.bil.INVALID_BARCODE, 'barcode');
    }

    if (mod(block) !== VD) {
      return error(errors.ptBr.bil.INVALID_BARCODE, 'barcode');
    }

    return null;
  }

  _getMod(code) {
    const coinCode = Number(code[2]);

    if (coinCode === 6 || coinCode === 7) {
      return this.mod10;
    } else if (coinCode === 8 || coinCode === 9) {
      return this.mod11;
    }

    return null;
  }

  getData() {
    const isValid = this.validate().isValid;

    if (!isValid) {
      return {
        value: 0
      };
    }

    const barcode = this.getBarcode();

    return {
      value: Number(barcode.substr(4, 11)) / 100
    };
  }

  getBlocks() {
    const code = this._billet.barcode;
    return Array.from(
      {
        length: 4
      },
      (v, index) => {
        const start = 11 * index + index;
        const end = 11 * (index + 1) + index;
        return {
          num: code.substring(start, end),
          VD: code.substring(end, end + 1)
        };
      }
    );
  }

  convertLineToBarcode() {
    return this.getBlocks().reduce((acc, b) => acc + b.num, '');
  }

  convertBarcodeToLine() {
    let barcode = this._billet.barcode;
    if (barcode.length !== 44) {
      throw new Error('Código de barras inválido');
    }

    const mod = this._getMod(barcode);

    const DV = mod(barcode.substr(0, 3) + barcode.substr(4));
    const field1 = barcode.substr(0, 3) + DV + barcode.substr(4, 7);
    const field2 = barcode.substr(11, 11);
    const field3 = barcode.substr(22, 11);
    const field4 = barcode.substr(33, 11);

    return field1 + mod(field1) + field2 + mod(field2) + field3 + mod(field3) + field4 + mod(field4);
  }

  getBarcode() {
    const code = this._billet.barcode;
    if (code.length === 44) {
      return code;
    } else if (code.length === 48) {
      return this.convertLineToBarcode();
    }

    return null;
  }

  getLine() {
    const code = this._billet.barcode;
    if (code.length === 44) {
      return this.convertBarcodeToLine();
    } else if (code.length === 48) {
      return code;
    }

    return null;
  }

  mod10(number) {
    const codigo = number.split('').reverse();
    const somatorio = codigo.reduce((acc, current, index) => {
      let soma = Number(current) * (((index + 1) % 2) + 1);
      soma = soma > 9 ? Math.trunc(soma / 10) + (soma % 10) : soma;
      return acc + soma;
    }, 0);
    return Math.ceil(somatorio / 10) * 10 - somatorio;
  }

  mod11(number) {
    const codigo = number.split('').reverse();
    let multiplicador = 2;
    const somatorio = codigo.reduce((acc, current) => {
      const soma = Number(current) * multiplicador;
      multiplicador = multiplicador === 9 ? 2 : multiplicador + 1;
      return acc + soma;
    }, 0);
    const restoDivisao = somatorio % 11;
    let DV = 11 - restoDivisao;

    if (restoDivisao === 10) {
      DV = 1;
    } else if (restoDivisao === 0) {
      DV = 0;
    } else if (DV === 10) {
      DV = 0;
    }
    return DV;
  }
}

module.exports = CollectionBarcode;
